import {
  DEFAULT_ACTIVITY_SETTINGS,
  type ActivityBridge,
  type ActivitySettings,
  type ActivityStatus,
} from './types';

const WEB_STATUS: ActivityStatus = {
  environment: 'web',
  state: 'unsupported',
  supported: false,
  message: 'Activity detection is available only in the DaySheetly desktop app.',
};

function unsupportedOperation(): never {
  throw new Error('Activity detection is not supported in this browser.');
}

export const webBridge: ActivityBridge = {
  async getStatus() {
    return { ...WEB_STATUS };
  },
  async getSettings() {
    return { ...DEFAULT_ACTIVITY_SETTINGS, excludedApps: [] };
  },
  async updateSettings(_settings: Partial<ActivitySettings>) {
    return { ...DEFAULT_ACTIVITY_SETTINGS, excludedApps: [] };
  },
  async setEnabled(_enabled: boolean) {
    return { ...WEB_STATUS };
  },
  async setPaused(_paused: boolean) {
    return { ...WEB_STATUS };
  },
  async listSegments() {
    return [];
  },
  async updateSegment() {
    return unsupportedOperation();
  },
  async deleteSegments() {},
  async deleteAllActivityData() {},
  async markSegmentImported() {},
  async listRules() {
    return [];
  },
  async saveRule() {
    return unsupportedOperation();
  },
  async deleteRule() {},
  async setActiveUser() {
    return { ...WEB_STATUS };
  },
  async exportDiagnostics() {
    return JSON.stringify(
      {
        generatedAt: new Date().toISOString(),
        ...WEB_STATUS,
        collectorVersion: 'web',
        retentionDays: DEFAULT_ACTIVITY_SETTINGS.retentionDays,
        idleThresholdMinutes: DEFAULT_ACTIVITY_SETTINGS.idleThresholdMinutes,
        idleDetectionAvailable: false,
        segmentCount: 0,
        ruleCount: 0,
        importCount: 0,
        includesWindowTitles: false,
      },
      null,
      2,
    );
  },
};
